// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SignatureBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29 20.5H8.794c.275-.552.551-1.117.823-1.691l.088-.183c1.695-.2 3.598-1.407 5.69-3.612.666 1.507 1.759 3.108 3.456 3.43.657.125 1.687.099 2.863-.726a7.16 7.16 0 0 0 1.135-1.008c1.041.953 2.885 1.79 6.151 1.79a1.5 1.5 0 1 0 0-3c-4.082 0-4.476-1.451-4.5-1.575a1.5 1.5 0 0 0-2.883-.5c-1.17 1.741-1.95 2.125-2.207 2.075-.614-.116-1.556-1.963-1.94-3.799a1.5 1.5 0 0 0-2.761-.46c-1.25 1.548-2.32 2.617-3.21 3.313 2.663-6.649 2.143-9.065 1.433-10.322-.625-1.108-1.75-1.722-3.17-1.728h-.04c-2.25.016-4.053 2.082-4.84 5.534-.432 1.89-.5 3.985-.183 5.742.33 1.836 1.041 3.209 2.076 4.028-.446.922-.9 1.828-1.344 2.692H3a1.5 1.5 0 1 0 0 3h.835c-1.21 2.209-2.105 3.7-2.125 3.726A1.5 1.5 0 0 0 3 29.5a1.5 1.5 0 0 0 1.286-.726c.078-.132 1.366-2.274 2.964-5.274H29a1.5 1.5 0 1 0 0-3ZM24.5 14v-.068a.4.4 0 0 1 0 .068ZM7.805 8.701C8.221 6.875 9.055 5.5 9.75 5.5c.459 0 .531.125.575.205.179.317.819 2.136-2.178 9.1a5.598 5.598 0 0 1-.497-1.555 11.861 11.861 0 0 1 .155-4.549Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
